import { format } from 'date-fns';
import { formatInTimeZone, utcToZonedTime } from 'date-fns-tz';
export const browserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
export function validTimezone(value) { try { if (!value) return false; new Intl.DateTimeFormat('en', {timeZone:value}); return true; } catch { return false; } }
export function calendarNow(timezone, now = new Date()) { return utcToZonedTime(now, timezone || browserTimezone()); }
export function calendarDay(value, timezone) { return formatInTimeZone(new Date(value), timezone || browserTimezone(), 'yyyy-MM-dd'); }
export function eventOnCalendarDay(event, day, timezone) {
  if (!event?.time || !day) return false;
  const eventDay = event.isAllDay ? String(event.time).slice(0,10) : calendarDay(event.time, timezone);
  return eventDay === format(day, 'yyyy-MM-dd');
}
export function calendarMinutes(value, timezone) {
  const [hour,minute] = formatInTimeZone(new Date(value), timezone || browserTimezone(), 'HH:mm').split(':').map(Number);
  return hour * 60 + minute;
}
